import { searchEngineOffsets, currentSearchEngine } from "config";
import React, { useCallback, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

const useCategory = (
  scrollLoading,
  hasMore,
  setoffset,
  offset,
  categoryType,
  subCategory
) => {
  const dataCount = (academiaSearch) => {
    return academiaSearch === "Academia" || academiaSearch === "Bing" ? 21 : 10;
  };

  const observer = useRef();

  const lastElementRef = useCallback(
    (node) => {
      if (scrollLoading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting && hasMore) {
            if (subCategory) {
              setoffset((prevOffset) => prevOffset + searchEngineOffsets["Academia"]);
            } else if (categoryType === "books") {
              setoffset((prevOffset) => prevOffset + searchEngineOffsets["Books"]);
            } else if (categoryType === "wiki") {
              setoffset((prevOffset) => prevOffset + searchEngineOffsets["Wiki"]);
            } else {
              setoffset(
                (prevOffset) =>
                  prevOffset + searchEngineOffsets[currentSearchEngine]
              );
            }
          }
        },
        {
          threshold: 0.1,
          rootMargin: '100px 0px 0px 0px'
        }
      );
      if (node && hasMore) {
        observer.current.observe(node);
      }
    },
    [scrollLoading, hasMore, subCategory, categoryType, setoffset]
  );

  return { lastElementRef, dataCount, setoffset, offset };
};

export default useCategory;
